import React, { PropsWithChildren } from 'react'
import { Spinner, Text, csx } from '@vtex/admin-ui'

const Loading = ({ children }: PropsWithChildren<Record<string, unknown>>) => (
  <>
    <Spinner
      size={50}
      className={csx({
        color: '$action.main.secondary',
        marginBottom: '$space-8',
      })}
    />

    <Text
      variant="display"
      className={csx({ textAlign: 'center', marginTop: '$space-5' })}
    >
      {children}
    </Text>
  </>
)

export default Loading
